import { render, staticRenderFns } from "./Presentations.vue?vue&type=template&id=6c3bd9ce"
import script from "./Presentations.vue?vue&type=script&lang=js"
export * from "./Presentations.vue?vue&type=script&lang=js"
import style0 from "./Presentations.vue?vue&type=style&index=0&id=6c3bd9ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports